module.exports = __webpack_public_path__ + "img/canduyet-sidebar-active.a74fafe4.svg";